import React, { useState, useEffect } from "react";
import { ERCText } from "components/text";
import { MdDateRange, MdAccessTimeFilled } from "react-icons/md";

const EventsCard = ({
  thumbnail,
  name,
  description,
  date,
  location,
  createdAt,
  startTime,
  endTime,
}) => {
  // State for storing countdown values
  const [countdown, setCountdown] = useState({
    days: "00",
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  // Calculate remaining time based on the event date
  useEffect(() => {
    const interval = setInterval(() => {
      // Create event date from ISO string
      const eventDate = new Date(date).getTime(); // Ensure date is in correct format
      const currentTime = Date.now(); // Get current time
      const timeDifference = eventDate - currentTime; // Calculate time difference
      console.log(timeDifference);

      if (timeDifference > 0) {
        // Calculate time components
        const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
        console.log("days", days);
        const hours = Math.floor(
          (timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor(
          (timeDifference % (1000 * 60 * 60)) / (1000 * 60)
        );
        const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);

        // Update countdown state
        setCountdown({
          days: String(days).padStart(2, "0"),
          hours: String(hours).padStart(2, "0"),
          minutes: String(minutes).padStart(2, "0"),
          seconds: String(seconds).padStart(2, "0"),
        });
      } else {
        clearInterval(interval); // Clear interval when event has passed
      }
    }, 1000);

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [date]);

  // Countdown Box Component
  const CountdownBox = ({ number, text }) => (
    <div className="flex flex-col items-center justify-center transition-all bg-lightYellow hover:bg-[#FFD600] rounded-md p-6 md:w-[126px] md:gap-6 gap-4">
      <h2 className="text-[32px] font-bold text-[#00296B]">{number}</h2>
      <h2 className="md:text-[20px] text-[#00296B]">{text}</h2>
    </div>
  );

  return (
    <div className="flex justify-between md:flex-row flex-col gap-12 md:p-8 px-6 w-full md:h-[447px]">
      {/* Image Section */}
      <div className="md:w-1/2 w-full   lg:flex">
        <img src={thumbnail} alt="" className="w-full h-full object-cover" />
      </div>

      {/* Content Section */}
      <div className="flex flex-col gap-12 md:w-1/2 w-full">
        {/* Countdown Timer */}
        <div className="grid grid-cols-4 gap-2">
          <CountdownBox number={countdown.days} text="Days" />
          <CountdownBox number={countdown.hours} text="Hours" />
          <CountdownBox number={countdown.minutes} text="Minutes" />
          <CountdownBox number={countdown.seconds} text="Seconds" />
        </div>

        {/* Event Description */}
        <div className="flex flex-col gap-4.5">
          <ERCText size="22px" weight="600" lHeight="24px">
            {name}
          </ERCText>
          <ERCText
            color="#3D3D3D"
            align="justify"
            size="16px"
            weight="400"
            lHeight="24px"
          >
            {description}
          </ERCText>
        </div>

        {/* Date and Time */}
        <div className="flex md:gap-12 gap-4 items-start md:text-[18px] font-bold">
          <div className="flex gap-3 items-center">
            <MdDateRange size={24} color="black" />
            <ERCText size="18px" weight="700">
              {date.split("T")[0]}
            </ERCText>{" "}
            {/* Display date part */}
          </div>
          <div className="flex gap-3 items-center md:text-[18px] font-bold">
            <MdAccessTimeFilled size={24} color="black" />
            <h1 className="" size="18px" weight="700">
              {startTime}
            </h1>
            <p>-</p>
            <h1>{endTime}</h1>
            <h1> {location}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventsCard;
